import React, { useState } from 'react';
import { api } from './api';

const HOUR = 3600e3;

// Presence from last activity (the server touches it on every request): in the last
// few minutes → live, today → recent, else quiet.
export function presence(iso) {
  if (!iso) return 'never';
  const age = Date.now() - new Date(iso).getTime();
  return age < 0.25 * HOUR ? 'live' : age < 24 * HOUR ? 'recent' : 'quiet';
}

export function ago(iso) {
  if (!iso) return 'never';
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60e3));
  if (m < 1) return 'now';
  if (m < 60) return `${m}m`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.round(h / 24);
  return d < 30 ? `${d}d` : `${Math.round(d / 30)}mo`;
}

const seen = m => m.last_seen_at || m.last_login_at;

const detail = m => {
  if (!seen(m)) return m.invited_by ? `invited by ${m.invited_by}` : 'not signed in yet';
  if (m.accounts == null) return 'private';
  if (m.accounts === 0) return m.is_me ? 'link a broker' : 'nothing linked';
  return `${m.accounts} account${m.accounts === 1 ? '' : 's'}`;
};

export default function Members({ members, used, limit, selected, onSelect, onChange }) {
  const [adding, setAdding] = useState(false);
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const full = used >= limit;

  const invite = async e => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      onChange(await api('/members', { method: 'POST', body: { email } }));
      setEmail(''); setAdding(false);
    } catch (err) { setError(err.message); }
    setBusy(false);
  };

  return (
    <nav className="df-members" aria-label="members">
      <h3>members <span className="df-muted">{used} / {limit}</span></h3>
      <ul>
        {members.map(m => (
          <li key={m.username} className={`${m.username === selected ? 'on' : ''} ${m.accounts ? '' : 'empty'}`}>
            <button onClick={() => onSelect(m.username)} title={seen(m) ? `last seen ${new Date(seen(m)).toLocaleString()}` : 'never signed in'}>
              <span className={`df-presence ${presence(seen(m))}`} />
              <span className="df-member-name">{m.username}{m.is_me && <em> you</em>}</span>
              <span className="df-member-ago">{ago(seen(m))}</span>
              <span className="df-member-detail">{detail(m)}</span>
            </button>
          </li>
        ))}
      </ul>
      {full ? (
        <p className="df-members-foot df-muted">all {limit} spots taken</p>
      ) : adding ? (
        <form className="df-invite" onSubmit={invite}>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="their gmail" autoFocus required />
          <div className="df-add">
            <button className="df-btn" type="submit" disabled={!email || busy}>{busy ? '…' : 'add'}</button>
            <button className="df-text" type="button" onClick={() => { setAdding(false); setError(''); }}>cancel</button>
          </div>
          {error && <p className="df-error">{error}</p>}
          <p className="df-muted df-fine">they sign in with that Google account. {limit - used} spot{limit - used === 1 ? '' : 's'} left.</p>
        </form>
      ) : (
        <button className="df-text df-members-foot" onClick={() => setAdding(true)}>+ add someone</button>
      )}
    </nav>
  );
}
